__turbopack_context__.v({
  "badge": "brandarea-module__mXqiuG__badge",
  "card": "brandarea-module__mXqiuG__card",
  "cardName": "brandarea-module__mXqiuG__cardName",
  "container": "brandarea-module__mXqiuG__container",
  "ctaBox": "brandarea-module__mXqiuG__ctaBox",
  "ctaBtn": "brandarea-module__mXqiuG__ctaBtn",
  "ctaIcon": "brandarea-module__mXqiuG__ctaIcon",
  "ctaText": "brandarea-module__mXqiuG__ctaText",
  "ctaTitle": "brandarea-module__mXqiuG__ctaTitle",
  "distance": "brandarea-module__mXqiuG__distance",
  "grid": "brandarea-module__mXqiuG__grid",
  "header": "brandarea-module__mXqiuG__header",
  "img": "brandarea-module__mXqiuG__img",
  "imgWrap": "brandarea-module__mXqiuG__imgWrap",
  "section": "brandarea-module__mXqiuG__section",
  "sectionPadding": "brandarea-module__mXqiuG__sectionPadding",
  "spin": "brandarea-module__mXqiuG__spin",
  "spinner": "brandarea-module__mXqiuG__spinner",
  "stateBox": "brandarea-module__mXqiuG__stateBox",
  "subtitle": "brandarea-module__mXqiuG__subtitle",
  "title": "brandarea-module__mXqiuG__title",
  "underline": "brandarea-module__mXqiuG__underline",
  "viewAllBtn": "brandarea-module__mXqiuG__viewAllBtn",
  "viewAllWrap": "brandarea-module__mXqiuG__viewAllWrap",
});
